import { FormGroup, FormLabel, FormSelect } from 'react-bootstrap';
import { useTheme } from 'styled-components';

interface CustomSelectProps {
  value?: string | number;
  title: string;
  disabled?: boolean;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  options: { value: any; label: string }[];
  style?: React.CSSProperties;
  required?: boolean;
  borderRadius?: string;
  'data-testid'?: boolean | string;
}

export default function CustomSelect({
  value,
  title,
  disabled,
  name,
  onChange,
  onClick,
  options,
  style,
  required,
  borderRadius = '10px',
  'data-testid': dataTestId,
}: CustomSelectProps) {
  const theme = useTheme();

  const controlId = name;

  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId === true
        ? `select-${controlId}`
        : undefined;

  return (
    <FormGroup>
      <FormLabel
        style={{ color: theme.colors.textoAzul }}
        data-testid={testId ? `${testId}-label` : undefined}
      >
        {required ? (
          <>
            <span
              style={{
                color: theme.colors.botaoConfirmar,
                fontWeight: 'bold',
              }}
            >
              {title}
            </span>
            <span
              style={{
                color: theme.colors.vermelho,
                fontWeight: 'bold',
              }}
            >
              {' *'}
            </span>
          </>
        ) : (
          title
        )}
      </FormLabel>
      <div
        onClick={(e) => {
          if (onClick) {
            e.stopPropagation(); // Evita propagação para o <FormSelect>
            onClick(e); // Chama a função passada como `onClick`
          }
        }}
        style={{
          position: 'relative',
          cursor: disabled ? 'default' : 'pointer',
          borderRadius: borderRadius,
          ...style,
        }}
      >
        <FormSelect
          value={value}
          disabled={disabled}
          onChange={onChange}
          name={name}
          required={required}
          data-testid={testId}
          style={{
            borderRadius: '10px',
            border: `1px solid ${theme.colors.bordaInput}`,
            cursor: disabled ? 'not-allowed' : 'pointer',
            pointerEvents: disabled ? 'none' : 'auto',
            ...style,
          }}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              hidden={option.value == '0' ? true : false}
            >
              {option.label}
            </option>
          ))}
        </FormSelect>
      </div>
    </FormGroup>
  );
}
